import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll to the top of the page on every route (pathname) change.
 *
 * React Router does not restore scroll position on navigation, so without this
 * a <Link> clicked from far down one page lands the user at the same scroll
 * offset on the next page — which looks like the new page "jumps to the bottom."
 *
 * - Query-string-only changes (e.g. ?tab=…) keep their scroll position.
 * - Hash links (/page#section) still scroll to their target element.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
